// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: Sc5S45VhMI7n
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Email1 from "../../Email1"; // plasmic-import: swTRIky6t0do/component
import Password1 from "../../Password1"; // plasmic-import: _8NThLJuHFRw/component
import CustomErrorComponent from "../../CustomErrorComponent"; // plasmic-import: 3fSxDxNzNmO_/component
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicLogin2.module.css"; // plasmic-import: Sc5S45VhMI7n/css
import hxDb1FtwEoXs111Cb9TCkLalCaAvifXr4Qffral7VX from "./images/hxDb1FtwEoXs111Cb9TCkLalCaAvif.avif"; // plasmic-import: Xr4qffral7vX/picture

createPlasmicElementProxy;

export const PlasmicLogin2__VariantProps = new Array();

export const PlasmicLogin2__ArgProps = new Array();

const $$ = {};

function PlasmicLogin2__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <PlasmicImg__
            data-plasmic-name={"img"}
            data-plasmic-override={overrides.img}
            alt={""}
            className={classNames(sty.img)}
            displayHeight={"90px"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={
              hasVariant(globalVariants, "screen", "mobile") ? "150px" : "179px"
            }
            loading={"lazy"}
            src={{
              src: hxDb1FtwEoXs111Cb9TCkLalCaAvifXr4Qffral7VX,
              fullWidth: 512,
              fullHeight: 512,
              aspectRatio: undefined
            }}
          />

          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__aTsSm
            )}
          >
            {"Welcome Back"}
          </div>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__d5DIr
            )}
          >
            {"Login to your account"}
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__fnM5W)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__pdul1
              )}
            >
              {"Email"}
            </div>
            <Email1
              data-plasmic-name={"loginEmailInput"}
              data-plasmic-override={overrides.loginEmailInput}
              className={classNames("__wab_instance", sty.loginEmailInput)}
            />

            <div
              data-plasmic-name={"invalidEmailText"}
              data-plasmic-override={overrides.invalidEmailText}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.invalidEmailText
              )}
            >
              {"Invalid email address"}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__fkwfJ)}>
            <div className={classNames(projectcss.all, sty.freeBox__ggHgl)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___7Eg1
                )}
              >
                {"Password"}
              </div>
              <div
                data-plasmic-name={"forgotPassword"}
                data-plasmic-override={overrides.forgotPassword}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.forgotPassword
                )}
              >
                {"Forgot your password?"}
              </div>
            </div>
            <Password1
              data-plasmic-name={"loginPasswordInput"}
              data-plasmic-override={overrides.loginPasswordInput}
              className={classNames("__wab_instance", sty.loginPasswordInput)}
            />

            <div
              data-plasmic-name={"incorrectLoginText"}
              data-plasmic-override={overrides.incorrectLoginText}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.incorrectLoginText
              )}
            >
              {"Incorrect email or password"}
            </div>
            <CustomErrorComponent
              data-plasmic-name={"customErrorInstance"}
              data-plasmic-override={overrides.customErrorInstance}
              className={classNames("__wab_instance", sty.customErrorInstance)}
              customErrorText={
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__taKlq
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Failed to login"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Failed to login"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
              }
            />
          </div>
          <div
            data-plasmic-name={"loginButton"}
            data-plasmic-override={overrides.loginButton}
            className={classNames(projectcss.all, sty.loginButton)}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text___5Zb7
              )}
            >
              {"Login"}
            </div>
          </div>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__thRqx
            )}
          >
            <React.Fragment>
              <span
                className={"plasmic_default__all plasmic_default__span"}
                style={{ color: "#000000" }}
              >
                {"Don\u2019t have an account?"}
              </span>
              <React.Fragment>{"  "}</React.Fragment>
              {
                <span
                  data-plasmic-name={"signupText"}
                  data-plasmic-override={overrides.signupText}
                  className={classNames(
                    projectcss.all,
                    projectcss.span,
                    projectcss.__wab_text,
                    projectcss.plasmic_default__inline,
                    sty.signupText
                  )}
                >
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#026B50" }}
                    >
                      {"Signup"}
                    </span>
                  </React.Fragment>
                </span>
              }

              <React.Fragment>{""}</React.Fragment>
            </React.Fragment>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "img",
    "loginEmailInput",
    "invalidEmailText",
    "forgotPassword",
    "loginPasswordInput",
    "incorrectLoginText",
    "customErrorInstance",
    "loginButton",
    "signupText"
  ],

  img: ["img"],
  loginEmailInput: ["loginEmailInput"],
  invalidEmailText: ["invalidEmailText"],
  forgotPassword: ["forgotPassword"],
  loginPasswordInput: ["loginPasswordInput"],
  incorrectLoginText: ["incorrectLoginText"],
  customErrorInstance: ["customErrorInstance"],
  loginButton: ["loginButton"],
  signupText: ["signupText"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicLogin2__ArgProps,
          internalVariantPropNames: PlasmicLogin2__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicLogin2__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicLogin2";
  } else {
    func.displayName = `PlasmicLogin2.${nodeName}`;
  }
  return func;
}

export const PlasmicLogin2 = Object.assign(
  // Top-level PlasmicLogin2 renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    img: makeNodeComponent("img"),
    loginEmailInput: makeNodeComponent("loginEmailInput"),
    invalidEmailText: makeNodeComponent("invalidEmailText"),
    forgotPassword: makeNodeComponent("forgotPassword"),
    loginPasswordInput: makeNodeComponent("loginPasswordInput"),
    incorrectLoginText: makeNodeComponent("incorrectLoginText"),
    customErrorInstance: makeNodeComponent("customErrorInstance"),
    loginButton: makeNodeComponent("loginButton"),
    signupText: makeNodeComponent("signupText"),
    // Metadata about props expected for PlasmicLogin2
    internalVariantProps: PlasmicLogin2__VariantProps,
    internalArgProps: PlasmicLogin2__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicLogin2;
/* prettier-ignore-end */
